<up-top-header />

<bt-sidenav></bt-sidenav>
<div class="shift-right page-margins">
	<!-- <bt-topbar></bt-topbar> -->
	<!-- <bt-loader [loaderId]="appLoader">-->
	<router-outlet></router-outlet>
	<!-- </bt-loader>-->
</div>
